import { render, staticRenderFns } from "./-MainBanner.vue?vue&type=template&id=365f23b8&scoped=true&"
import script from "./-MainBanner.vue?vue&type=script&lang=js&"
export * from "./-MainBanner.vue?vue&type=script&lang=js&"
import style0 from "./-MainBanner.vue?vue&type=style&index=0&id=365f23b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365f23b8",
  null
  
)

export default component.exports